import { Component, ReactNode } from 'react';
import { createPortal } from 'react-dom';

type Props = {
  id: string;
  portalClassName?: string;
  styles?: Record<string, string>;
  children: ReactNode;
};

export class Portal extends Component<Props> {
  node: HTMLElement | null = null;

  componentDidMount() {
    if (!this.node) {
      this.node = document.createElement('div');
    }

    if (this.props.portalClassName) {
      this.node.className = this.props.portalClassName;
    }

    this.node.setAttribute('data-cy', `modal-${this.props.id}`);
    document.body.appendChild(this.node);
  }

  componentDidUpdate() {
    if (!this.node) return;

    if (this.props.portalClassName) {
      this.node.className = this.props.portalClassName;
    }
  }

  componentWillUnmount() {
    if (!this.node) return;
    document.body.removeChild(this.node);
  }

  render() {
    if (typeof window !== 'object') {
      return null;
    }

    return this?.node && createPortal(this.props.children, this.node);
  }
}
